import camelcaseKeys from "camelcase-keys";

import {
  authorizedGet,
  authorizedPatch,
  authorizedPost,
} from "@onsite_app/MobileOrderingMenu/authorizedRequests";

import {
  VoucherCart,
  VoucherCartSchema,
  VoucherCheckoutSchema,
  VouchersSchema,
} from "./schema";

export const fetchCurrentVoucherCart = async () => {
  const { body } = await authorizedGet({
    url: `/v1/voucher_carts/current`,
  });
  return VoucherCartSchema.parse(
    camelcaseKeys(body.voucher_cart, { deep: true }),
  );
};

export const updateVoucherCart = async (voucherCart: VoucherCart) => {
  const { body } = await authorizedPatch({
    url: `/v1/voucher_carts/${voucherCart.uuid}`,
    body: {
      purchaser_email: voucherCart.purchaserEmail,
    },
  });
  return VoucherCartSchema.parse(
    camelcaseKeys(body.voucher_cart, { deep: true }),
  );
};

export const createVoucherCartCheckout = async (voucherCartUuid: string) => {
  const { body } = await authorizedPost({
    url: `/v1/voucher_checkouts`,
    body: {
      voucher_cart_uuid: voucherCartUuid,
    },
  });
  return {
    checkoutUrl: body.checkout_url,
  };
};

export const fetchVoucherCartCheckout = async (uuid: string) => {
  const { body } = await authorizedGet({
    url: `/v1/voucher_checkouts/${uuid}`,
  });
  return VoucherCheckoutSchema.parse(
    camelcaseKeys(body.voucher_checkout, { deep: true }),
  );
};

export const fetchVoucherCartCheckoutVouchers = async (
  voucherCartUuid: string,
) => {
  const { body } = await authorizedGet({
    url: `/v1/vouchers?voucher_cart_uuid=${voucherCartUuid}`,
  });
  return VouchersSchema.parse(camelcaseKeys(body.vouchers, { deep: true }));
};
